/**
 * Created by nguyendx 2017/12/01.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import {ApiEvsService} from './ApiEvs.service';
import {Observable} from 'rxjs/Observable';

// @ts-ignore
@Injectable({
  providedIn: 'root'
})
export class BusinessService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  getDetailBusiness() {
    return this.get_qr_aps('/users/me/profile');
  }

  getDetailBusinessById(id?) {
    return this.get('/profile_owner/' + id);
  }

  updateBusiness(data: any) {
    return this.put_qr_aps('/users/me/profile', data);
  }

  resetPassword(data: any) {
    return this.post('/change-password', data);
  }

  // resetPassword(data: any) {
  //   return this.postDatahub("/user/change-password", data);
  // }
  forgotPassword(data: any) {
    return this.post('/forgot-password', data);
  }

  getInbox(option: any) {
    return this.get(`/inbox`, option);
  }

  readedMess(id: any) {
    return this.get(`/inbox/` + id);
  }

  refreshToken() {
    this.get('/refresh-firebase')
      .toPromise()
      .then((data: any) => {
        localStorage.setItem('FireBase-Token', data.data);
      });
  }

  pushOTP(data: any) {
    return this.post('/create-otp', data);
  }

  changePassword(data) {
    return this.post('/verify-otp', data);
  }

  /**Tuanba: 19-09-2022: Hiện thị phần retarget **/
  getRetarget() {
    return this.get_qr_core_aps('/account/retarget')
  }

  getBusinessContact(): Observable<any> {
    return this.get_qr_core_aps('/account/contact')
  }

  updateBusinessContact(body): Observable<any> {
    return this.put_qr_core_aps('/account/contact', body)
  }

  /**Tuanba: 06-11-2023: Hiện thị phần retarget **/

  getListAccountSync() {
    return this.get_qr_core_aps('/account/sync')
  }

  /**Tuanba: 26-2-2024: Đổi mật khẩu khi đăng nhập lần đầu **/
  changePasswordLoginFirst(data) {
    return this.post_new_token('/change-password', data)
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/Business.service.ts